import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import {
    FormBuilder,
    FormControl,
    FormGroup
} from '@angular/forms';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
//import { formComponentMapOptions } from '~/front-models/form-component-map';
import { ShipTransaction } from '~/front-models/transactionGrid';
import { ComponentBase } from '~/infrastructure/component-base';
import { GridFieldSummary } from '~/models/modules/gridField';
import { AccountsService } from '~/services/administration.ts/accounts';
import { AccountsDropdownComponent } from '~/shared/components/accounts-dropdown/accounts-dropdown.component';
import { ReportsService } from '~/services/modules/reports/reports';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { LayoutManagerService } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { ReportViewerPopupComponent } from '../../../../shared/components/viewer/popup.component';
import { PageState } from '~/shared/enums/stock-files.enum';
import { UserSummary } from '~/models/administration/user';
import { SecurityService } from '~/services/security.service';
import { PackListWtihTransactionNumberListing } from '~/models/modules/packList';
import { PackListsService } from '~/services/modules/stocks/packList';
import { SalesOrderDetailForShip } from '~/front-models/salesOrderGrid';
import { IssueTransactionsService } from '~/services/modules/stocks/issue-transaction';
import { ShipSettingsService } from '~/services/administration.ts/ship-settings';
import { ShipSetting } from '~/models/administration/shipSetting';
import { ShipTransactionsService } from '~/services/modules/stocks/ship-transaction';
import { UsersService } from '~/services/administration.ts/users';
import { SignatureComponent } from '~/shared/components/signature/signature.component';
import { FormatService } from '~/services/administration.ts/format';
import { GridFieldTextSummary } from '~/models/modules/GridFieldText';
import { GridFieldAuthorization } from '~/models/administration/securityLevel';
import { EnvironmentLoaderService } from '~/services/BackEndURL/environment-loader.service';
import { Router } from '@angular/router';
import { SharedService } from '~/services/sharedService';
import { SitesEnum } from '~/shared/enums/sites.enum';
@Component({
    selector: 'app-stock-ship',
    templateUrl: './ship.html',
    styleUrls: ['./ship.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StockShipComponent extends ComponentBase implements OnInit {
    page: string = 'transaction-ship';
    title: string = 'Ship';
    showTextBox = false;

    _currentUser: UserSummary;
    _theme: string;
    _form: FormGroup;
    _form_signAndProcess: FormGroup;
    _invalidForm: boolean;
    _invalidForm_signAndProcess: boolean;
    _selectedAccount = new FormControl();
    _sortingSelected = new FormControl('old');
    _sites: any[];
    _sitesFiltered: any[];
    _isMultiSiteSelected: boolean = false;
    _inventoryGridData: ShipTransaction[] = [];
    _stockItemsGridColumns: GridFieldSummary[];
    transactionId: number;
    _packAgainstSO: boolean = false;
    _addClassActive: boolean = false;
    _packList: PackListWtihTransactionNumberListing[] = [];
    _packListFiltered: PackListWtihTransactionNumberListing[];
    _packReportId: number;
    OpenSignAndProcessForm: boolean = false;
    OpenCreateShippingAndProcessForm: boolean = false;
    _selectedCarrier: string = null;
    _shipSetting: ShipSetting;

    _carrierConfigs: { [key: string]: any } = {
        UPS: {
            name: 'UPS',
            dropOffTypes: [
                'Regular Daily Pickup',
                'Customer Counter',
                'One Time Pickup',
                'On Call Air',
                'Letter Center',
                'Air Service Center'
            ],
            defaultDropOffType: 'Regular Daily Pickup',
            serviceTypes: [
                'UPS Next Day Air',
                'UPS 2nd Day Air',
                'UPS Ground',
                'UPS Worldwide Express',
                'UPS Worldwide Expedited',
                'UPS Standard',
                'UPS 3 Day Select',
                'UPS Next Day Air Saver',
                'UPS Next Day Air Early A.M.',
                'UPS Worldwide Express Plus'
            ],
            defaultServiceType: 'UPS Ground',
            packagingTypes: [
                'Customer Supplied Package',
                'UPS Letter',
                'UPS Tube',
                'UPS PAK',
                'UPS Express Box',
                'UPS 25KG Box',
                'UPS 10KG Box'
            ],
            defaultPackagingType: 'Customer Supplied Package',
            signatureOptions: [
                'No Signature Required',
                'Signature Required',
                'Adult Signature Required'
            ],
            defaultSignatureOption: 'No Signature Required',
            paymentTypes: [
                'Prepaid',
                'Bill Third Party',
                'Freight Collect',
                'Consignee Billed'
            ],
            defaultPaymentType: 'Prepaid',
            customerRefTypes: [
                'Reference 1',
                'Reference 2'
            ]
        },
        FedEx: {
            name: 'FedEx',
            dropOffTypes: [
                'REGULAR_PICKUP',
                'REQUEST_COURIER',
                'DROP_BOX',
                'BUSINESS_SERVICE_CENTER',
                'STATION'
            ],
            defaultDropOffType: 'REGULAR_PICKUP',
            serviceTypes: [
                'FEDEX_GROUND',
                'GROUND_HOME_DELIVERY',
                'FEDEX_2_DAY',
                'FEDEX_2_DAY_AM',
                'FEDEX_EXPRESS_SAVER',
                'STANDARD_OVERNIGHT',
                'FIRST_OVERNIGHT',
                'PRIORITY_OVERNIGHT',
                'INTERNATIONAL_ECONOMY',
                'INTERNATIONAL_FIRST',
                'INTERNATIONAL_PRIORITY'
            ],
            defaultServiceType: 'FEDEX_GROUND',
            packagingTypes: [
                'YOUR_PACKAGING',
                'FEDEX_ENVELOPE',
                'FEDEX_BOX',
                'FEDEX_PAK',
                'FEDEX_TUBE',
                'FEDEX_10KG_BOX',
                'FEDEX_25KG_BOX'
            ],
            defaultPackagingType: 'YOUR_PACKAGING',
            signatureOptions: [
                'SERVICE_DEFAULT',
                'NO_SIGNATURE_REQUIRED',
                'INDIRECT',
                'DIRECT',
                'ADULT'
            ],
            defaultSignatureOption: 'SERVICE_DEFAULT',
            paymentTypes: [
                'SENDER',
                'RECIPIENT',
                'THIRD_PARTY',
                'COLLECT'
            ],
            defaultPaymentType: 'SENDER',
            customerRefTypes: [
                'CUSTOMER_REFERENCE',
                'INVOICE_NUMBER',
                'P_O_NUMBER',
                'SHIPMENT_INTEGRITY'
            ]
        },
        DHL: {
            name: 'DHL',
            dropOffTypes: [
                'Regular Pickup',
                'Request Courier'
            ],
            defaultDropOffType: 'Regular Pickup',
            serviceTypes: [
                'Express Worldwide',
                'Express 9:00',
                'Express 10:30',
                'Express 12:00',
                'Express Envelope'
            ],
            defaultServiceType: 'Express Worldwide',
            packagingTypes: [
                'Customer Provided',
                'DHL Flyer',
                'Jumbo Document',
                'Jumbo Parcel',
                'Document'
            ],
            defaultPackagingType: 'Customer Provided',
            signatureOptions: [
                'Standard',
                'Direct Signature'
            ],
            defaultSignatureOption: 'Standard',
            paymentTypes: [
                'Shipper',
                'Recipient',
                'Third Party'
            ],
            defaultPaymentType: 'Shipper',
            customerRefTypes: [
                'Shipment Reference'
            ]
        }
    };

    _dropOffTypes: string[] = [];
    _selectedDropOffType: string = null;
    _serviceTypes: string[] = [];
    _selectedServiceType: string = null;
    _packagingTypes: string[] = [];
    _selectedPackagingType: string = null;
    _signatureOptions: string[] = [];
    _selectedSignatureOption: string = null;
    _paymentTypes: string[] = [];
    _selectedPaymentType: string = null;
    _customerRefTypes: string[] = [];
    _selectedCustomerRefType: string = null;

    _shippingShipDate: Date = new Date();
    _shippingInsuredValue: string = '';
    _shippingNumPackages: number = 1;
    _shippingLength: number = null;
    _shippingWidth: number = null;
    _shippingHeight: number = null;
    _shippingWeightLbs: number = null;
    _shippingWeightOz: number = null;
    _shippingCustomerRefValue: string = '';
    _shippingAccountNumber: string = '';
    _shippingMeterNumber: string = '';
    _shippingCountryCode: string = 'US';

    _shippingSender: any = {
        name: '',
        company: '',
        phone: '',
        email: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        country: 'US'
    };

    _shippingRecipient: any = {
        name: '',
        company: '',
        phone: '',
        email: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        country: 'US'
    };

    _shipAgainstSO: boolean = false;
    _onlyShipPacked: boolean = true;
    _signatureRequired: boolean = true;
    _persons: any[];
    _personsFiltered: any[];
    _signatureAdded: boolean = false;

    _datePickerFormat: string;
    _costFormat: string;

    _pageState: PageState;

    _selectedAccountIds: any[] = [];
    _language: string = 'en';
    _page: string = 'ship-transactions';
    _selectedLabelText: any;
    _selectedLabelObjectCode: any;
    _editFormActive: boolean;
    _isTransaction: boolean = false;
    _onlyRequired: boolean = false;
    _hasRequired: boolean = false;

    _isRenameFormValue: boolean = false;
    _isRenameCustomFormValue: boolean = false;
    _isRenameLabel: boolean = false;
    _isMandatory: boolean = false;
    _isCustomfieldsFormValue: boolean = false;
    _isAddTabFormValue: boolean = false;

    _gridFieldText: GridFieldTextSummary[];
    _gridFieldAuth: GridFieldAuthorization[];

    @ViewChild('kendo_combo_accounts') kendoComboAccounts: AccountsDropdownComponent;
    @ViewChild('kendo_combo_sites') kendoComboSites: ComboBoxComponent;
    @ViewChild('kendo_combo_Pack_list') kendoComboPackList: ComboBoxComponent;
    @ViewChild('Kendo_Input_Transaction_note') KendoInputTransactionnote: ElementRef;
    @ViewChild('kendo_combo_Person_ID') kendocomboPersonID: ComboBoxComponent;
    @ViewChild('Kendo_Input_Notes') KendoInputNotes: ElementRef;

    @ViewChild('signature', { static: false }) shipSignature: SignatureComponent;

    constructor(
        private _fb: FormBuilder,
        private _themeManager: ThemeManagerService,
        private _accountsService: AccountsService,
        private _layoutComponent: LayoutComponent,
        private _layoutManager: LayoutManagerService,
        private _gridLayoutManagerService: GridLayoutManagerService,
        private _gridFields: GridFieldsService,
        private _sharedService: SharedService,
        private _securityService: SecurityService,
        private _packListsService: PackListsService,
        private _issueTransactionsService: IssueTransactionsService,
        private _shipTransactionsService: ShipTransactionsService,
        private _shipSettingsService: ShipSettingsService,
        private _reportService: ReportsService,
        private _usersService: UsersService,
        private _formatService: FormatService,
        private router: Router
    ) {
        super();
        this._themeManager.themeChange.subscribe((data) => {
            this._theme = data;
        });

        this._layoutManager.okCloseClicked.subscribe((data) => {
            if (data) {
                if (this._currentUser?.isEnterprise && this._form.get('site').value == null) {
                    setTimeout(() => {
                        this.kendoComboAccounts.toggle(true);
                        this.kendoComboAccounts.focus();
                    });
                } else {
                    setTimeout(() => {
                        this.kendoComboPackList.toggle(true);
                        this.kendoComboPackList.focus();
                    });
                }
            }
        });

        this._gridFields
            .getGridFieldsByPage('stockItems')

            .subscribe((data: any) => {
                this._gridLayoutManagerService.setGridColumnSubjects('stockItems', data);
            });

        this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('stockItems', (gridColumns) => {
            this._stockItemsGridColumns = gridColumns;
        }));

        this._getReportIdByName('Pack List Default Print');
        this._currentUser = this._securityService.currentUser;
        this._pageState = PageState.ADD;
        this.loadLabels();
    }
    closeTextbox(event: any) {
        //this.title=event.value;
        this._gridFields.EditPageTitle(this.page, event.value).subscribe((data: any) => {
            this.title = data.titleName;
            this._sharedService.TitleChanged.emit(true);
        });
        this.showTextBox = false;
    }
    showTextbox() {
        this.showTextBox = true;
        //document.getElementById('titleTextBox').focus();
        //this.titleTextBox.nativeElement.focus();
    }

    ngOnInit() {
        this._gridFields.getPageByName(this.page).subscribe((data) => {
            if (data.titleName) {
                this.title = data.titleName;
            }
        });

        this._initForm();
        this._OpenAccount();


        this._shipSettingsService.getShipSetting()

            .subscribe(res => {
                this._shipSetting = res;
                this._shipAgainstSO = res.shipVerification == "againstSaleOrder";
                this._onlyShipPacked = res.onlyShipPacked;
                this._signatureRequired = res.signatureRequired;
                this._initForm();
                this._loadPackListForShip();
            });

        this._selectedAccount.valueChanges.subscribe((x) => {
            if (x) {
                if (this._isMultiSiteSelected) {
                    this._form.get('site').setValue(null);
                }
                this._accountsService.getSitesListByAccount(x.id)
                    .subscribe((data: any) => {
                        this._sites = data.filter((x: any) => x.id != SitesEnum.AllSites);
                        this._sitesFiltered = this._sites;

                        if (this._isMultiSiteSelected && this.kendoComboSites) {
                            setTimeout(() => {
                                this.kendoComboSites.toggle(true);
                                this.kendoComboSites.focus();
                            });
                        }
                    });
            }
        });

        this._sortingSelected.valueChanges.subscribe((x) => {
            this._inventoryGridData.reverse();
        });

        this._form.get('site').valueChanges.subscribe((x) => {
            if (x) {
                setTimeout(() => {
                    this.kendoComboPackList.toggle(true);
                    this.kendoComboPackList.focus();
                });
            }
        });

        /** Format */
        this._datePickerFormat = this._formatService.dateFormat;
        this._costFormat = this._formatService.costFormatValue;
    }
    _OpenAccount() {
        if (this._currentUser?.isEnterprise) {
            setTimeout(() => {
                this.kendoComboAccounts.toggle(true);
                this.kendoComboAccounts.focus();
            });
        }
        else {
            setTimeout(() => {
                this.kendoComboPackList.toggle(true);
                this.kendoComboPackList.focus();
            });
        }
    }

    private loadLabels() {
        this._gridFields.getGridFieldTextLabelByPage(this._page, this._language)

            .subscribe((data: GridFieldTextSummary[]) => {
                this._gridFieldText = data;
                this._initForm();
            })
    }
    ClosePopup(event: boolean) {
        if (event == true) {
            this._closeCustomFields();
        }
    }
    _onStateChanges(e: any) {
        if (e === 'minimized') {
            this._layoutManager.removeOverlay();
        } else {
            this._layoutManager.applyOverly();
        }
    }
    getAuth() {
        // this._gridFields.getFileAuthorization(this._auth, this._currentUser.appRole.id)
        this._gridFields.getFieldsAuthorization(this._page, this._currentUser?.appRole.id)

            .subscribe((x: GridFieldAuthorization[]) => {
                this._gridFieldAuth = x;
            });
    }
    getLabel(objectCode: any) {
        if (this._gridFieldText) {
            if (this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode))
                var result = this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode)
            else
                result = null

            return result ? result : null;
        }
    }

    _OpenSignAndProcessForm() {
        if (this._form.invalid) {
            this._invalidForm = true;
        } else {
            this._loadPersonsDD();
            this.OpenSignAndProcessForm = true;
            this._layoutManager.applyOverly();
            setTimeout(() => {
                this.kendocomboPersonID.toggle();
                this.kendocomboPersonID.focus();
            });
            this._addClassActive = false;
        }
    }
    _closeSignAndProcessForm() {
        this._onClear_signAndProcess();
        this._signatureAdded = false;
        this._invalidForm_signAndProcess = false;
        this.OpenSignAndProcessForm = false;
        this.ngOnDestroy();
        this._addClassActive = false;

    }
    ngOnDestroy() {
        this._layoutManager.removeOverlay();
    }

    _editFormState() {
        this._pageState = PageState.EDIT_FIELDS;
    }

    _returnAddNew() {
        this._pageState = PageState.ADD;
    }

    _openRenameForm(objectCode: string, isMandatory: boolean = false, onlyRequired: boolean = false, hasRequired: boolean = false) {
        this._selectedLabelText = this.getLabel(objectCode)?.text;
        this._selectedLabelObjectCode = objectCode;
        //todo send system field label id
        //return;
        //open form once label id is set
        this._editFormActive = true;
        this._isRenameFormValue = true;
        this._isRenameCustomFormValue = false;
        this._isRenameLabel = true;
        this._isMandatory = isMandatory;
        this._isTransaction = true;
        this._onlyRequired = onlyRequired;
        this._hasRequired = hasRequired;
    }
    _closeCustomFields() {
        this._editFormActive = false;
        this._isCustomfieldsFormValue = false;
        this._isAddTabFormValue = false;
        this._isRenameFormValue = false;
        // this.loadCustomFields(this._model?.id?.toString());
        this.loadLabels();
        // this.getFormTabs();
        this.getAuth();
        this._isTransaction = false;
        this._onlyRequired = false;
        this._hasRequired = false;

    }
    _OpenCreateShippingAndProcessForm() {
        if (this._form.invalid) {
            this._invalidForm = true;
        } else {
            this.OpenCreateShippingAndProcessForm = true;
            this._layoutManager.applyOverly();
            this._addClassActive = false;
            this._onCarrierChange(this._selectedCarrier || 'UPS');
            if (this._currentUser) {
                const fullName = [this._currentUser.firstName, this._currentUser.lastName].filter(Boolean).join(' ') || this._currentUser.userName || '';
                this._shippingSender.name = fullName;
                this._shippingSender.email = this._currentUser.email || '';
                this._shippingSender.phone = this._currentUser.contactPhone1 || '';
                this._shippingSender.address1 = this._currentUser.addressLine1 || '';
                this._shippingSender.address2 = this._currentUser.addressLine2 || '';
                this._shippingSender.city = this._currentUser.addressCity || '';
                this._shippingSender.state = this._currentUser.addressState || '';
                this._shippingSender.zip = this._currentUser.addressZip || '';
                if (this._currentUser.addressCountry) {
                    this._shippingSender.country = this._currentUser.addressCountry;
                }
            }
            if (this.transactionId) {
                this._shippingCustomerRefValue = this.transactionId.toString();
            }
        }
    }
    _closeCreateShippingAndProcessForm() {
        this.OpenCreateShippingAndProcessForm = false;
        this.ngOnDestroy();
        this._addClassActive = false;
    }
    _onCarrierChange(carrier: string) {
        this._selectedCarrier = carrier;
        const config = this._carrierConfigs[carrier];
        if (config) {
            this._dropOffTypes = [...config.dropOffTypes];
            this._selectedDropOffType = config.defaultDropOffType;

            this._serviceTypes = [...config.serviceTypes];
            this._selectedServiceType = config.defaultServiceType;

            this._packagingTypes = [...config.packagingTypes];
            this._selectedPackagingType = config.defaultPackagingType;

            this._signatureOptions = [...config.signatureOptions];
            this._selectedSignatureOption = config.defaultSignatureOption;

            this._paymentTypes = [...config.paymentTypes];
            this._selectedPaymentType = config.defaultPaymentType;

            this._customerRefTypes = [...config.customerRefTypes];
            this._selectedCustomerRefType = config.customerRefTypes[0];

            if (carrier === 'UPS') {
                this._shippingAccountNumber = this._shipSetting?.ups || '';
                this._shippingMeterNumber = '';
            } else if (carrier === 'FedEx') {
                this._shippingAccountNumber = this._shipSetting?.fedEx || '';
                this._shippingMeterNumber = this._shipSetting?.meterNumber || '';
            } else if (carrier === 'DHL') {
                this._shippingAccountNumber = this._shipSetting?.dhl || '';
                this._shippingMeterNumber = '';
            }
        }
    }
    _packListNumberChange() {
        setTimeout(() => {
            this.KendoInputTransactionnote.nativeElement.focus();
            let TransactionNotes = this.KendoInputTransactionnote;
            TransactionNotes.nativeElement.classList.add('focusedInput');
        });
    }
    _personIDChange() {
        setTimeout(() => {
            this.KendoInputNotes.nativeElement.focus();
            let Notes = this.KendoInputNotes;
            Notes.nativeElement.classList.add('focusedInput');
        });
    }
    _handlePersonsFilter(value: any) {
        this._personsFiltered = this._persons.filter(
            (s) => s.code != null && s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
        );
    }
    _skipTransactionNotes() {
        let TransactionNotes = this.KendoInputTransactionnote;
        TransactionNotes.nativeElement.classList.remove('focusedInput');
        TransactionNotes.nativeElement.blur();
        this._addClassActive = true;
    }
    _focustransactionNotes() {
        let TransactionNotes = this.KendoInputTransactionnote;
        TransactionNotes.nativeElement.classList.add('focusedInput');
        this._addClassActive = false;
    }
    _focusOutTransactionNotes() {
        setTimeout(() => {
            let TransactionNotes = this.KendoInputTransactionnote;
            TransactionNotes.nativeElement.classList.remove('focusedInput');
        }, 200);
    }

    _personIDOpenEvent() {
        let Notes = this.KendoInputNotes;
        Notes.nativeElement.classList.remove('focusedInput');
        this._addClassActive = false;
    }
    _focusNotes() {
        let Notes = this.KendoInputNotes;
        Notes.nativeElement.classList.add('focusedInput');
        this._addClassActive = false;
    }
    _accountOpenEvent() {
        let TransactionNotes = this.KendoInputTransactionnote;
        TransactionNotes.nativeElement.classList.remove('focusedInput');
        this._addClassActive = false;
    }
    _siteOpenEvent() {
        let TransactionNotes = this.KendoInputTransactionnote;
        TransactionNotes.nativeElement.classList.remove('focusedInput');
        this._addClassActive = false;
    }
    _packListOpenEvent() {
        let TransactionNotes = this.KendoInputTransactionnote;
        TransactionNotes.nativeElement.classList.remove('focusedInput');
        this._addClassActive = false;
    }
    _focusOutNotes() {
        setTimeout(() => {
            let Notes = this.KendoInputNotes;
            Notes.nativeElement.classList.remove('focusedInput');
        }, 200);
    }

    _skipNotes() {
        let Notes = this.KendoInputNotes;
        Notes.nativeElement.classList.remove('focusedInput');
        Notes.nativeElement.blur();
        this._addClassActive = true;
    }

    async _loadPersonsDD() {
        return (await this._usersService.getPersons())
            .subscribe((data: any) => {
                this._persons = data;
                this._personsFiltered = data;
            });
    }

    _handleSitesFilter(value: any) {
        this._sitesFiltered = this._sites.filter(
            (s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
        );
    }


    _loadPackListForShip() {
        return this._packListsService.getPackListsListingForShip(this._shipAgainstSO, this._onlyShipPacked)
            .subscribe((data) => {
                this._packList = data;
                this._packListFiltered = data;
                this._packListFiltered.forEach((item: any) => {
                    item.Concat = item.packingListNumber + "  | " + item.transactionNumber;
                });
                setTimeout(() => {
                    this.kendoComboPackList.toggle(true);
                    this.kendoComboPackList.focus();
                });
            });
    }

    _handlePackListsSelection(value: any) {
        this._inventoryGridData = [];
        if (value != null && value.id != null && value.transactionNumber != null) {
            setTimeout(() => {
                this.transactionId = value.transactionNumber;
                this._issueTransactionsService.getIssueDetails(value.transactionNumber)

                    .subscribe((data: any) => {
                        data.forEach((item: SalesOrderDetailForShip) => {
                            this._inventoryGridData.push({
                                transactionNumber: item.stockIssueId,
                                historyDate: item.createdOn,
                                inventoryCode: item.inventoryNumber,
                                itemNumber: item.stock?.number,
                                locationCode: item.location?.code,
                                customerCode: item.customer?.code,
                                soNumber: item.stockSalesOrder?.soNumber
                            });
                        });
                    });
            });
        } else {
            this.transactionId = null;
        }
    }

    async _onSave(e: any) {
        let signatureValue = null;
        if (this.OpenSignAndProcessForm) {
            if (this._form_signAndProcess.invalid) {
                this._invalidForm_signAndProcess = true;
                return;
            } else {
                this._invalidForm_signAndProcess = false;
            }
            if (this.shipSignature) {
                signatureValue = await this.shipSignature.renderAsPNG();
            }
            if (!signatureValue && this.shipSignature) {
                signatureValue = this.shipSignature._signatureValue;
            }
            if (!signatureValue) {
                this._layoutComponent.openPopup({
                    title: 'Alert',
                    message: 'Signature is required',
                    returnAfterOkCloseClick: true,
                    withoutConfirm: true
                });
                return;
            }
        }
        if (this._signatureRequired && !signatureValue) {
            if (this.shipSignature) {
                signatureValue = await this.shipSignature.renderAsPNG();
            }
            if (!signatureValue) {
                this._layoutComponent.openPopup({
                    title: 'Alert',
                    message: 'Signature is required',
                    returnAfterOkCloseClick: true,
                    withoutConfirm: true
                });
                return;
            }
        }
        if (this._form.invalid) {
            this._invalidForm = true;
        } else {
            this._invalidForm = false;
            const formModel = this._form.value;
            let model: any = {};
            model['shipped'] = true;
            model['shippingNotes'] = formModel.notes;
            if (this._form_signAndProcess.value.person != null) {
                const personVal = this._form_signAndProcess.value.person;
                model['shippedByPersonId'] = typeof personVal === 'object' ? personVal.id : personVal;
                model['signatureStream'] = signatureValue;
                if (this.KendoInputNotes && this.KendoInputNotes.nativeElement) {
                    model['SignatureNotes'] = this.KendoInputNotes.nativeElement.value;
                }
            }
            var transactionNumber =
                this._shipAgainstSO ? (formModel.salesOrder?.transactionNumber || formModel.salesOrder) : (formModel.packList?.transactionNumber || formModel.packList);

            if (!transactionNumber && this.transactionId) {
                transactionNumber = this.transactionId;
            }

            this._shipTransactionsService
                .updateShip(transactionNumber, model)

                .subscribe((data: any) => {
                    var msg = "";
                    if (data != null && data.message != null) {
                        msg = 'Successfully shipped.';
                        this._loadPackListForShip();
                    } else {
                        msg = 'Error';
                    }

                    this._layoutComponent.openPopup({
                        title: 'Alert',
                        message: msg,
                        returnAfterOkCloseClick: true,
                        withoutConfirm: true
                    });
                    this._onClear();

                });
        }
    }


    _getReportIdByName(reportname: string) {
        this._reportService.ReportIdByName(reportname)
            .subscribe(
                (reportid) => {
                    switch (reportname) {
                        case 'Pack List Default Print':
                            this._packReportId = reportid;
                            break;
                        default:
                            break;
                    }
                }
            );
    }

    _printReceiptReport() {
        if (this.transactionId != null) {
            var reportId = this._packReportId; //get pack report id by name "Pack List Default Print"
            this._layoutComponent.openDialogForm(ReportViewerPopupComponent, PageState.VIEW, { reportId: reportId, transactionId: this.transactionId });
        } else {
            if (this._form.invalid) {
                this._invalidForm = true;
            }
        }
    }

    _openForm(formName: string) {
        //this._layoutComponent.openDialogForm(formComponentMapOptions[formName]);
    }

    _onClear() {
        this.transactionId = null;
        this._initForm();
        this._selectedAccount.setValue(null);
        this._inventoryGridData = [];
        this.kendoComboPackList.reset();
        this._invalidForm = false;
        this._invalidForm_signAndProcess = false;
        this._closeSignAndProcessForm();
        this._selectedCarrier = null;
        this._shippingAccountNumber = '';
        this._shippingMeterNumber = '';
        this._shippingCustomerRefValue = '';
        this._OpenAccount();
    }

    _onClear_signAndProcess() {
        this._form_signAndProcess = this._fb.group({
            person: null,
            signature: null
        });
    }

    private _initForm() {
        if (this._shipAgainstSO) {
            this._form = this._fb.group({
                site: [null],
                salesOrder: null,
                notes: null
            });
        } else {
            this._form = this._fb.group({
                site: [null],
                packList: null,
                notes: null
            });
        }
        this._form_signAndProcess = this._fb.group({
            person: null,
            signature: null
        });
        const loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? "";
        if (loggedInAccountSites != "") {
            const parsedSites = JSON.parse(loggedInAccountSites);
            if (parsedSites && parsedSites.length > 0) {
                var accountId = parsedSites[0].accountId;
                if (!this._currentUser?.isEnterprise) {
                    this._selectedAccount.setValue({ id: accountId });
                }
                var siteId = parsedSites[0].siteId;
                if (!siteId && !this._currentUser?.isEnterprise) {
                    this.router.navigate(['/']);
                }
                if (siteId != null && siteId != SitesEnum.AllSites && siteId != 0) {
                    this._isMultiSiteSelected = false;
                    this._form.get('site')?.setValue(siteId);
                } else {
                    this._isMultiSiteSelected = true;
                }
            } else {
                this._isMultiSiteSelected = true;
            }
        } else {
            this._isMultiSiteSelected = true;
        }
    }

}
